export default class OfferListSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.wrapper = this.root.querySelector('[data-offer-list-grid]');
        this.moreEl = this.root.querySelector('[data-offer-list-more]');

        this.moreLoader = null;
        this.masonry = null;

        if (this.moreEl)
            this.moreLoader = this.moreEl.querySelector('.button__loader');

        this.settings = JSON.parse(this.root.getAttribute('data-settings'));
        this.currentPage = 1;
        this.maxPages = parseInt(this.settings.max_pages);
        this.html = this.wrapper.innerHTML;

        return true;
    }

    init() {
        this.initMore();
        this.gridHandler();
        this.onResize();
    }

    initMore() {
        if (!this.moreEl) return;
        this.moreEl.addEventListener('click', this.onMoreClick.bind(this));
    }

    onResize() {
        window.addEventListener('resize', this.gridHandler.bind(this));
    }

    gridHandler() {
        const { innerWidth } = window;
        const cards = this.root.querySelectorAll('.card-offer');
        if (!cards) return;

        const cardsArr = Array.from(cards);
        const gridCols = (innerWidth > 992) ? 3 : 1;
        const gridArr = new Array(Math.ceil(cardsArr.length / gridCols))
            .fill()
            .map(_ => cardsArr.splice(0, gridCols));

        gridArr.forEach((cardsItems) => {
            let maxTitleHeight = 0;
            let maxDetailsHeight = 0;

            cardsItems.forEach((item, index) => {
                const detailsEl = item.querySelector('.card-offer__details');
                detailsEl.style.height = `auto`;
                const detailsRect = detailsEl.getBoundingClientRect();
                const detailsHeight = detailsRect.height;

                const titleEl = item.querySelector('.card-offer__title');
                const titleRect = titleEl.getBoundingClientRect();
                const { height } = titleRect;
    
                if (height > maxTitleHeight) maxTitleHeight = height;
                if (detailsHeight > maxDetailsHeight) maxDetailsHeight = detailsHeight;
            })
    
            cardsItems.forEach(item => {
                const detailsEl = item.querySelector('.card-offer__details');
                const contentEl = item.querySelector('.card-offer__content');

                detailsEl.style.height = `${maxDetailsHeight}px`;
                contentEl.style.height = `${maxTitleHeight}px`;
    
                if (innerWidth < 992) {
                    contentEl.style.height = `auto`;
                    detailsEl.style.height = `auto`;
                }
            })
        })
    }

    onMoreClick(event) {
        let page = this.currentPage + 1;

        if (page > this.maxPages) {
            page = this.maxPages;
            this.currentPage = page;
        } else {
            this.currentPage = page;
            this.loadOffers();
        }

        //if (this.currentPage === this.maxPages)
        //this.moreEl.classList.add('d-none');
    }

    loadOffers() {
        this.moreLoader.classList.remove('d-none');

        const formData = new FormData();
        formData.append('action', 'get_offers');
        formData.append('page', this.currentPage);
        formData.append('per_page', this.settings.per_page);
        formData.append('category', this.settings.category);

        $.ajax({
            type: 'POST',
            url: ajax.url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                const data = JSON.parse(response);
                const { html, max_pages, ids } = data;

                this.maxPages = parseInt(max_pages);
                this.html += html;

                this.wrapper.innerHTML = this.html;
                this.gridHandler();

                if (ids.length > 0 && ids.length < this.settings.per_page) {
                    this.moreEl.classList.add('d-none');
                } else {
                    this.moreEl.classList.remove('d-none');
                }
            }.bind(this),
            error: function () {}.bind(this),
            complete: function () {
                this.moreLoader.classList.add('d-none');

                if (this.currentPage === this.maxPages)
                    this.moreEl.classList.add('d-none');
            }.bind(this),
        });
    }
}
